import React from 'react';
import { BookOpenIcon, FolderOpenIcon, GiftIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 tomos completos'
}, {
  icon: GiftIcon,
  label: '5 bonos estratégicos'
}, {
  icon: FolderOpenIcon,
  label: '+300 recursos listos para usar'
}, {
  icon: UsersIcon,
  label: 'Docentes, estudiantes y profesionales'
}];
export function SocialProof() {
  return <section className="border-b border-line bg-panel py-5" aria-label="Contenido del Megapack" data-id="element-213" data-mp="3ebmjbaalryk">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-muted sm:justify-between" data-id="element-214" data-mp="8ehhp1frtwle">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-215" data-mp="3usr4x77ysykl">
            <Icon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-216" data-mp="mdpks5f21ouv" /> {label}
          </span>)}
      </div>
    </section>;
}